import { MatDialogConfig } from '@angular/material/dialog';

export const FullscreenMobileModalConfig: MatDialogConfig = {
  panelClass: 'fullscreen-mobile-modal',
  width: '100vw',
  maxWidth: '100vw',
  position: { right: '0', top: '0' },
  height: '100dvh',
  maxHeight: '100dvh',
  autoFocus: false,
};
